module.exports = __webpack_public_path__ + "static/media/standing-thinking-svgrepo-com.df0f6100.svg";